import { SubPage, Tab } from '@symfa-inc/providence-types';
import { TabAccessGuard } from '@core/guards/tab-access.guard';
import { TabProps } from '@models/classes/models';
import {
  PermittingContacts,
  PermittingFinancial,
  PermittingJurisdictionAudit,
  PermittingSOFTab,
  PermittingSummary,
  PermittingWorkflow,
} from '../details/tabs';

export const PERMITTING_TABS_PROPS: TabProps[] = [
  {
    path: '/summary',
    component: PermittingSummary,
    name: 'Summary',
    guards: [
      new TabAccessGuard('permitting', SubPage.PermittingBrowse, Tab.Summary),
    ],
  },
  {
    path: '/workflow',
    component: PermittingWorkflow,
    name: 'Workflow',
    guards: [
      new TabAccessGuard('permitting', SubPage.PermittingBrowse, Tab.Workflow),
    ],
  },
  {
    path: '/jurisdiction-audit',
    component: PermittingJurisdictionAudit,
    name: 'Jurisdiction Audit',
    guards: [
      new TabAccessGuard(
        'permitting',
        SubPage.PermittingBrowse,
        Tab.JurisdictionAudit,
      ),
    ],
  },
  {
    path: '/contacts',
    component: PermittingContacts,
    name: 'Contacts',
    guards: [
      new TabAccessGuard('permitting', SubPage.PermittingBrowse, Tab.Contacts),
    ],
  },
  {
    breadcrumbName: 'SOF Tool-:siteNumber(:projectBundleID)',
    path: '/sof',
    name: 'SOF',
    component: PermittingSOFTab,
    guards: [
      new TabAccessGuard('permitting', SubPage.PermittingBrowse, Tab.SOF),
    ],
  },
  {
    path: '/financial',
    component: PermittingFinancial,
    name: 'Financial',

    guards: [
      new TabAccessGuard('permitting', SubPage.PermittingBrowse, Tab.Financial),
    ],
  },
];
